import { ApiInstance } from '../api/api';
import { UserMapDataType } from '../types/analyticTypes';

export interface ActionLogUsersData {
  userMap: UserMapDataType;
}

/**
 * Route louder - resolves the user data from action logs before AnalyticPage renders.
 */
export const actionLogUsersLoader = async (): Promise<ActionLogUsersData> => {
  const { users } = await ApiInstance.getUsersFromActionLogs();
  return { userMap: users };
};
